import PageState from "./state"
import mutations from "./mutations"
import {getModule} from '@/store/store'
let APIS = {
    getSpeakerSearchList: `get /apis/tts-web-api/speaker/store/search`, // 获取发音人
	getSpeakerEmotionList: `get /apis/tts-web-api/v1/speaker/getSpeakerEmotionList`, // 获取所有风格 含该风格的表情包
}
export default {
    ...getModule({
        state: new PageState(),
        mutations,
        actions:{},
        APIS,
        name:'FesitvalSpeakerPopup'
    })
}